import { QueryMapOperandEnum, type QueryFormatFilter } from '@hotjar/global-filters';

import type { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { getRecordingValueForOption } from './getRecordingValueForOption';
import type { SimilarRecordingsFilterOption } from '../types';

export const generateQueryFormatFilterForSimilarRecordings = (
  recording: Recording,
  selectedFilters: Array<SimilarRecordingsFilterOption>,
): QueryFormatFilter => ({
  AND: selectedFilters.map((selectedFilter) => ({
    [QueryMapOperandEnum.EQUAL]: {
      [selectedFilter]: getRecordingValueForOption(selectedFilter, recording),
    },
  })),
});
